import { useEffect, useState } from 'react';

/** Tiny toast store (§5.7: failed actions show retry / discard). */
export interface Toast {
  id: number;
  text: string;
  kind: 'info' | 'error';
  actions?: { label: string; run: () => void }[];
  /** ms; 0 = sticky */
  ttl: number;
}

let seq = 0;
let toasts: Toast[] = [];
const listeners = new Set<(t: Toast[]) => void>();

function emit() {
  for (const l of listeners) l(toasts);
}

export function toast(text: string, opts: Partial<Omit<Toast, 'id' | 'text'>> = {}): number {
  const t: Toast = { id: ++seq, text, kind: opts.kind ?? 'info', actions: opts.actions, ttl: opts.ttl ?? (opts.actions ? 0 : 4000) };
  toasts = [...toasts.filter((x) => x.text !== text), t];
  emit();
  if (t.ttl) setTimeout(() => dismiss(t.id), t.ttl);
  return t.id;
}

export function dismiss(id: number): void {
  if (!toasts.some((t) => t.id === id)) return;
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export function useToasts(): Toast[] {
  const [list, setList] = useState(toasts);
  useEffect(() => {
    listeners.add(setList);
    return () => {
      listeners.delete(setList);
    };
  }, []);
  return list;
}
